import { Routes } from '@angular/router';
import { AutorisationAggregate } from './aggregats/autorisation/autorisation.aggregate';
import { AutorisationsAggregate } from './aggregats/autorisation/autorisations.aggregate';
import { AppPath } from './app-path';
import { FonctionLogicielle } from './constantes/fonctions-logicielle-constantes';
import { accueilMenuItem } from './constantes/menu/menu-items/left/accueil/menu-item.constantes';
import { donneesMenuItem } from './constantes/menu/menu-items/left/donnees/menu-item.constantes';
import { articlesSousMenuItem } from './constantes/menu/menu-items/left/donnees/sous-menu-items.constantes';
import {
  dossiersFinancementSousMenuItem,
  exportComptableSousMenuItem,
  facturationSousMenuItemSuivi,
  facturationSousMenuItemTraitement,
} from './constantes/menu/menu-items/left/financier/sous-menu-items.constantes';
import {
  formationsCatalogueSousMenuItem,
  inscriptionsSousMenuItem,
  planningFormateursSousMenuItem,
  planningRessourcesSousMenuItem,
  sessionsSousMenuItem
} from './constantes/menu/menu-items/left/formation/sous-menu-items.constantes';
import {
  automatisationsSousMenuItem,
  connecteursSousMenuItem,
  entitesSousMenuItem,
  parametresSousMenuItem,
  personnelsSousMenuItem,
  profilsDroitsSousMenuItem,
} from './constantes/menu/menu-items/left/parametrages/sous-menu-items.constantes';
import { entreprisesSousMenuItem } from './constantes/menu/menu-items/left/relation-clients/sous-menu-items.constantes';
import { OperationFonction } from './constantes/operations-fonctions.constantes';
import { AuthenticatedGuard } from './guards/authenticated.guard';
import { AuthorizedGuard } from './guards/authorized.guard';
import { ConfigReadyGuard } from './guards/config-ready.guard';
import { ExportComptableResolver } from './resolvers/export-comptable/export-comptable-resolver';
import { FormationResolverService } from './resolvers/formation-resolver/formation-resolver.service';
import { processEditorResolver } from './pages/parametres/process/process-editor.resolver';
import { processCreationGuard } from './pages/parametres/process/process-creation.guard';

export const APP_ROUTES: Routes = [
  {
    path: AppPath.ROOT,
    redirectTo: '/accueil',
    pathMatch: 'full',
  },
  {
    path: AppPath.LOGIN,
    loadChildren: () => import('./pages/connexion/connexion.module').then(m => m.ConnexionModule),
    canActivate: [ConfigReadyGuard]
  },
  {
    path: AppPath.LOGINFA,
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginModule),
    canActivate: [ConfigReadyGuard]
  },
  {
    path: AppPath.ACCUEIL,
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./pages/accueil/accueil.module').then(m => m.AccueilModule),
    canActivate: [ConfigReadyGuard, AuthenticatedGuard],
  },

  {
    path: AppPath.LOGOUT,
    loadComponent: () => import('./pages/logout/logout.component').then(m => m.LogoutComponent),
    canActivate: [ConfigReadyGuard],
  },
  {
    path: AppPath.ACCUEIL,
    runGuardsAndResolvers: 'always',
    loadChildren: () => import('./pages/accueil/accueil.module').then(m => m.AccueilModule),
    canActivate: [ ConfigReadyGuard, AuthorizedGuard, AuthenticatedGuard],
  },
  {
    path: AppPath.NON_AUTORISE,
    loadChildren: () => import('./pages/non-autorise/non-autorise.module').then(m => m.NonAutoriseModule),
  },
  {
    path: AppPath.PROFILS_DROITS,
    loadChildren: () => import('./pages/profils-droits/profils-droits.module').then(m => m.ProfilsDroitsModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: profilsDroitsSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.CONNECTEURS,
    loadChildren: () => import('./pages/connecteurs/connecteurs.module').then(m => m.ConnecteursModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: connecteursSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.PERSONNES,
    loadChildren: () => import('./pages/personnes/personnes.module').then(m => m.PersonnesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
  },
  {
    path: AppPath.FORMATEURS,
    loadChildren: () => import('./pages/formateurs/formateurs.module').then(m => m.FormateursModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
  },
  {
    path: AppPath.INSCRIPTION,
    loadChildren: () => import('./pages/inscriptions/inscriptions.module').then(m => m.InscriptionsModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
  },
  {
    path: AppPath.INSCRIPTIONS_PARCOURS,
    loadChildren: () => import('./pages/inscriptions-parcours/inscriptions-parcours-module').then(m => m.InscriptionsParcoursModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
  },
  {
    path: AppPath.ENTITES,
    loadChildren: () => import('./pages/entites/entites.module').then(m => m.EntitesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: entitesSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.PARAMETRES,
    loadChildren: () => import('./pages/parametres/parametres.module').then(m => m.ParametresModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: parametresSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.FORMATIONS,
    loadChildren: () => import('./pages/formations/formations.module').then(m => m.FormationsModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: formationsCatalogueSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.STATISTIQUES,
    loadChildren: () => import('./pages/statistiques/statistiques.module').then(m => m.StatistiquesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
  },
  {
    path: AppPath.SESSIONS,
    loadChildren: () => import('./pages/sessions/sessions.module').then(m => m.SessionsModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: sessionsSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.PARCOURS,
    loadChildren: () => import('./pages/parcours/parcours.module').then(m => m.ParcoursModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      formation: FormationResolverService,
      autorisations: sessionsSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.SEANCES,
    loadChildren: () => import('./pages/seances/seances.module').then(m => m.SeancesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: sessionsSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.PLANNING_FORMATEURS,
    loadChildren: () => import('./pages/emploi-du-temps/planning-formateurs/planning-formateurs.module').then(m => m.PlanningFormateursModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: planningFormateursSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.INSCRIPTIONS_FORMATION,
    loadChildren: () => import('./pages/inscriptions-formation/inscriptions-formation.module').then(m => m.InscriptionsFormationModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: inscriptionsSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.DEMO,
    loadChildren: () => import('./pages/demo/demo/demo.module').then(m => m.DemoModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: new AutorisationsAggregate([
        new AutorisationAggregate(FonctionLogicielle.Demo, OperationFonction.Actif),
      ]),
    },
  },
  {
    path: AppPath.ENTREPRISES,
    loadChildren: () => import('./pages/entreprises/entreprises.module').then(m => m.EntreprisesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: entreprisesSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.PERSONNELS,
    loadChildren: () => import('./pages/personnels/personnels.module').then(m => m.PersonnelsModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: personnelsSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.ARTICLES,
    loadChildren: () => import('./pages/articles/articles.module').then(m => m.ArticlesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: articlesSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.COMPTABILITE,
    loadComponent: () => import('./pages/export-comptable/export-comptable.component').then(mod => mod.ExportComptableComponent),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: exportComptableSousMenuItem.autorisations,
    },
    resolve: {
      canExport: ExportComptableResolver
    },
    runGuardsAndResolvers: 'always'
  },
  {
    path: AppPath.DOSSIERS_FINANCEMENT,
    loadChildren: () =>
      import('./pages/dossiers-financement/dossiers-financement.module').then(m => m.DossiersFinancementModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: dossiersFinancementSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.FACTURATION,
    loadChildren: () => import('./pages/facturation/facturation.module').then(m => m.FacturationModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: facturationSousMenuItemSuivi.autorisations,
    },
  },
  {
    path: AppPath.AVOIR,
    loadChildren: () => import('./pages/avoirs/avoirs.module').then(m => m.AvoirsModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: facturationSousMenuItemSuivi.autorisations,
    },
  },
  {
    path: AppPath.FACTURATION_TRAITEMENT,
    loadChildren: () => import('./pages/facturation/facturation-traitement.module').then(m => m.FacturationTraitementModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: facturationSousMenuItemTraitement.autorisations,
    },
  },
  {
    path: AppPath.PUBLIPOSTAGE_MODELES,
    loadChildren: () =>
      import('./pages/publipostage-modeles/publipostage-modeles.module').then(m => m.PublipostageModelesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {},
  },
  {
    path: AppPath.EVALUATIONS,
    loadChildren: () =>
      import('./pages/evaluations/evaluations.module').then(m => m.EvaluationsModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {},
  },
  {
    path: AppPath.RESSOURCES,
    loadChildren: () => import('./pages/ressources/ressources.module').then(m => m.RessourcesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: donneesMenuItem.autorisations,
    },
  },
  {
    path: AppPath.AGENDA_TACHES,
    loadChildren: () => import('./pages/agenda-taches/agenda-taches.module').then(m => m.PlanningTachesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: accueilMenuItem.autorisations,
    },
  },
  {
    path: AppPath.IMPORTS,
    loadChildren: () => import('./pages/imports/imports.module').then(m => m.ImportsModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: connecteursSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.PLANNING_RESSOURCES,
    loadChildren: () => import('./pages/emploi-du-temps/planning-ressources/planning-ressources.module').then(m => m.PlanningRessourcesModule),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: planningRessourcesSousMenuItem.autorisations,
    },
  },
  {
    path: AppPath.E_PROCESS,
    loadComponent: () => import('./pages/parametres/process/librairy-process/librairy-process.component').then(m => m.LibrairyProcessComponent),
    canActivate: [ConfigReadyGuard, AuthorizedGuard],
    data: {
      autorisations: automatisationsSousMenuItem.autorisations,
    },
    children: [
      {
        path: AppPath.E_PROCESS_CREATE,
        loadComponent: () => import('./pages/parametres/process/process.component').then(m => m.ProcessComponent),
        canActivate: [ConfigReadyGuard, AuthorizedGuard, processCreationGuard],
        data: {
          autorisations: automatisationsSousMenuItem.autorisations,
        },
      },
      {
        path: `${AppPath.E_PROCESS_EDIT}/:processId`,
        loadComponent: () => import('./pages/parametres/process/process.component').then(m => m.ProcessComponent),
        canActivate: [ConfigReadyGuard, AuthorizedGuard],
        data: {
          autorisations: automatisationsSousMenuItem.autorisations,
        },
        resolve: {
          processToEdit: processEditorResolver,
        },
      },
    ],
  },
  {
    path: AppPath.ERREUR404,
    loadChildren: () => import('./pages/not-found/not-found.module').then(m => m.NotFoundModule),
  },
  {
    path: '**',
    redirectTo: '/404',
  }
];
